import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useWalmartOnboardingStatus = () => {
  return useQuery({
    queryKey: ["walmart-onboarding-status"],
    queryFn: async () => await apiClient.getWalmartOnboardingStatus(),
    staleTime: 30000, // Consider stale after 30 seconds, updated via manual invalidation
  });
};
